import React from 'react';
import './svg.css';

const FilterLogo = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_564_7563)">
        <path d="M11.2502 8.75004V15.4167L8.75016 17.9167V8.75004L2.0835 2.08337H17.9168L11.2502 8.75004Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_564_7563">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default FilterLogo;